<!--Search Options and Data-->
<div class="InfoBody">
	<div>
		<div class="BasicFlex">
			<label style="min-width: 63px">Date Range</label>
			<select
				[disabled]="IsLoading() == true"
				class="form-control smallLeftMargin"
				name="DateRangeOptionID"
				[(ngModel)]="DateRangeOptionID"
				(ngModelChange)="onDateRangeOptionIDChange($event)"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstDateRangeOption" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>
		</div>

		<div class="Grid4Col TopMargin" *ngIf="DateRangeOptionID == -1">
			<label>Start Date</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="StartDate"
				name="StartDate"
				(ngModelChange)="onStartDateChange($event)"
			></p-calendar>

			<label class="largeLeftMargin">End Date</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="EndDate"
				name="EndDate"
				(ngModelChange)="onEndDateChange($event)"
			></p-calendar>
		</div>

		<div class="TopMargin BasicFlex">
			<label>Filter Time By:</label>
			<div class="Grid6Col largeLeftMargin">
				<input
					[disabled]="IsLoading() == true"
					type="radio"
					class="RAD"
					name="TimeOptionID"
					[(ngModel)]="TimeOptionID"
					id="AllTime"
					[value]="0"
					(ngModelChange)="onTimeOptionIDChange($event)"
				/>
				<label for="AllTime">All</label>

				<input
					[disabled]="IsLoading() == true"
					type="radio"
					class="RAD largeLeftMargin"
					name="TimeOptionID"
					[(ngModel)]="TimeOptionID"
					id="StartEnd"
					[value]="1"
					(ngModelChange)="onTimeOptionIDChange($event)"
				/>
				<label for="StartEnd">Time Range</label>

				<input
					[disabled]="IsLoading() == true"
					type="radio"
					class="RAD largeLeftMargin"
					name="TimeOptionID"
					[(ngModel)]="TimeOptionID"
					id="Period"
					value="2"
					(ngModelChange)="onTimeOptionIDChange($event)"
				/>
				<label for="Period">Period</label>
			</div>
		</div>

		<div *ngIf="TimeOptionID == 1" class="Grid6Col TopMargin">
			<label [disabled]="IsLoading() == true">Start Time</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[timeOnly]="true"
				hourFormat="12"
				[(ngModel)]="StartTime"
				name="StartTime"
				(ngModelChange)="onStartTimeChange($event)"
			></p-calendar>

			<label [disabled]="IsLoading() == true" class="largeLeftMargin">End Time</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[timeOnly]="true"
				hourFormat="12"
				[(ngModel)]="EndTime"
				name="EndTime"
				(ngModelChange)="onEndTimeChange($event)"
			></p-calendar>
		</div>

		<div *ngIf="TimeOptionID == 2" class="Grid2Col TopMargin">
			<label>Period:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="PeriodID" [(ngModel)]="PeriodID" (ngModelChange)="onPeriodChange($event)">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstPeriod" [ngValue]="o.PeriodID">
					{{ o.PeriodFullDesc }}
				</option>
			</select>
		</div>

		<div class="TopMargin">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>
		</div>
	</div>

	<div class="InfoGrid TopMargin">
		<label>Current Count:</label>
		<label *ngIf="StatsLoading == false" class="InfoText">{{ ConsequenceCount }}</label>

		<label class="largeLeftMargin">Count Mode:</label>
		<label *ngIf="StatsLoading == false" class="InfoText">{{ AccumulationModeDesc }}</label>
	</div>
</div>

<!--Table-->
<div>
	<p-table
		#mydt
		[value]="lstHallSweep"
		[loading]="TableLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedHallSweep"
		dataKey="HallsweepID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--ConsequenceDesc-->
				<th>
					<p-columnFilter field="ConsequenceDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterConsequenceDesc
								[ngModel]="value"
								[options]="lstConsequenceDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--LevelID-->
				<th>
					<!-- <p-columnFilter type="text" field="LevelID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ConsequenceTrigger-->
				<th>
					<!-- <p-columnFilter type="text" field="ConsequenceTrigger" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--AdminName-->
				<th>
					<p-columnFilter type="text" field="AdminName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--c_date-->
				<th>
					<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--PeriodDesc-->
				<th>
					<p-columnFilter field="PeriodDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPeriodDesc
								[ngModel]="value"
								[options]="lstPeriodDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="ConsequenceDesc">Consequence<p-sortIcon field="ConsequenceDesc"></p-sortIcon></th>
				<th pSortableColumn="LevelID">Count<p-sortIcon field="LevelID"></p-sortIcon></th>
				<th pSortableColumn="ConsequenceTrigger">Triggered at<p-sortIcon field="ConsequenceTrigger"></p-sortIcon></th>
				<th pSortableColumn="AdminName">Admin<p-sortIcon field="AdminName"></p-sortIcon></th>
				<th pSortableColumn="c_date">Date/Time<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="PeriodDesc">Period<p-sortIcon field="PeriodDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-HallSweep>
			<tr [pSelectableRow]="HallSweep">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ HallSweep[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
